/**
 * Offline booking queue - stores booking requests when offline, syncs when back online.
 */

const QUEUE_KEY = 'ebooking_offline_queue'

export function getOfflineQueue() {
  try {
    const raw = localStorage.getItem(QUEUE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function addToOfflineQueue(booking) {
  const queue = getOfflineQueue()
  queue.push({ ...booking, queuedAt: new Date().toISOString() })
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue))
}

export function clearOfflineQueue() {
  localStorage.removeItem(QUEUE_KEY)
}

export function removeFromQueue(index) {
  const queue = getOfflineQueue()
  queue.splice(index, 1)
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue))
}

export function isOnline() {
  return typeof navigator !== 'undefined' && navigator.onLine
}
